import React, { useEffect } from "react";
import * as echarts from "echarts";

const QualityVsTightnessBar = ({ data }) => {
  useEffect(() => {
    // Initialize bar graph container
    const chartContainer = document.getElementById(
      "shot-quality-vs-tightness-graph"
    );
    const chart = echarts.init(chartContainer);

    // Define bar graph options
    const options = {
      title: {
        text: "Quality & Tightness",
        left: "left",
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        // Custom tooltip formatter to include percentage
        formatter: function (params) {
          let tooltip = params[0].name + "<br/>";
          params.forEach(function (item) {
            let totalSum;
            if (item.seriesName === "Tight") {
              totalSum =
                data?.High?.Tight + data?.High?.Medium + data?.High?.Loose;
            } else if (item.seriesName === "Medium") {
              totalSum =
                data?.High?.Tight + data?.High?.Medium + data?.High?.Loose;
            } else if (item.seriesName === "Loose") {
              totalSum =
                data?.Low?.Tight + data?.Low?.Medium + data?.Low?.Loose;
            }
            tooltip +=
              item.seriesName +
              ": " +
              item.value +
              " (" +
              ((item.value / totalSum) * 100).toFixed(2) +
              "%)<br/>";
          });
          return tooltip;
        },
      },
      legend: {
        data: ["Tight", "Medium", "Loose"],
      },
      xAxis: {
        type: "category",
        name: "Quality",
        data: ["High", "Medium", "Low"],

        axisLabel: {
          interval: 0,
          rotate: 45,
          formatter: (value) => {
            return value !== " " ? value : "Shot Types"; // Show "Shot Types" at the last category position
          },
        },
      },
      yAxis: {
        type: "value",
        name: "Shots",
      },
      series: [
        {
          name: "Tight",
          type: "bar",
          stack: "Ad",
          emphasis: {
            focus: "series",
          },
          data: [data?.High?.Tight, data?.High?.Medium, data?.High?.Loose],
          color: "#1fd137",
        },
        {
          name: "Medium",
          type: "bar",
          stack: "Ad",
          emphasis: {
            focus: "series",
          },
          data: [
            data?.Medium?.Tight,
            data?.Medium?.Medium,
            data?.Medium?.Loose,
          ],
          color: "#faf74d",
        },
        {
          name: "Loose",
          type: "bar",
          stack: "Ad",
          emphasis: {
            focus: "series",
          },
          data: [data?.Low?.Tight, data?.Low?.Medium, data?.Low?.Loose],
          color: "#ff6259",
        },
      ],
    };

    // Set options and render chart
    chart.setOption(options);

    // Cleanup function to dispose chart when component unmounts
    return () => {
      chart.dispose();
    };
  }, [data]);

  return (
    <>
      <div
        id="shot-quality-vs-tightness-graph"
        style={{ width: "50%", height: "400px" }}
      ></div>
    </>
  );
};

export default QualityVsTightnessBar;
